var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconComet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 120,
    viewBox: "0 0 126 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 0H118.508V7.49233H126V0Z",
    fill: "#035B8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 22.4771H111.741V29.9694H118.508V22.4771Z",
    fill: "#035B8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 7.49219H111.741V14.9845H118.508V7.49219Z",
    fill: "#035B8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.741 29.9692H104.249V37.4616H111.741V29.9692Z",
    fill: "#035B8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.248 7.49219H96.7561V14.9845H104.248V7.49219Z",
    fill: "#035B8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7562 44.9541H89.2639V52.4464H96.7562V44.9541Z",
    fill: "#035B8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7562 29.9692H89.2639V37.4616H96.7562V29.9692Z",
    fill: "#035B8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7562 14.9849H89.2639V22.4772H96.7562V14.9849Z",
    fill: "#035B8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2792 52.5266V44.9538H66.7063H59.214V37.4614H51.7217V44.9538V52.5266H59.214V60.019H66.7063V66.7057V74.2786H74.2792V66.7057H81.7716V60.019H89.2639V52.5266H81.7716H74.2792Z",
    fill: "#035B8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7716 37.4614H74.2793V44.9538H81.7716V37.4614Z",
    fill: "#035B8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7716 22.4771H74.2793V29.9694H81.7716V22.4771Z",
    fill: "#035B8C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2791 37.4616V29.9692H66.7062H59.2139V37.4616H66.7062H74.2791Z",
    fill: "#035B8C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7716 66.7061H74.2793V74.1984H81.7716V66.7061Z",
    fill: "#0071BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7062 66.7062V60.0195H59.2139V66.7062V74.2791V81.7715H66.7062H74.2791V74.2791H66.7062V66.7062Z",
    fill: "#0071BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7213 52.527V44.9541H44.2289H37.4617V52.527H44.2289V60.0193H51.7213H59.2136V52.527H51.7213Z",
    fill: "#0071BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4768 74.2788V81.7711V89.2635H29.9691V81.7711V74.2788H22.4768Z",
    fill: "#8CDEF4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2134 81.7711V74.2788V66.7059V60.0192H51.7211H44.2287V52.5269H37.4615H29.9691V60.0192H22.4768V66.7059H29.9691V74.2788H37.4615H44.2287V81.7711V89.2634H51.7211V96.7558H59.2134V89.2634H66.7057V81.7711H59.2134Z",
    fill: "#3FA9F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9692 89.2635H22.4768V81.7711V74.2788H14.9845H7.49219V81.7711V89.2635V96.7558V104.248H14.9845H22.4768H29.9692H37.4615V96.7558V89.2635H29.9692Z",
    fill: "#9FDEED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2291 89.2635V81.7711V74.2788H37.4618H29.9695V81.7711V89.2635H37.4618V96.7558V104.248H29.9695V111.74H37.4618H44.2291V104.248H51.7214V96.7558V89.2635H44.2291Z",
    fill: "#78D0EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4769 66.7061H14.9846V74.2789H22.4769H29.9693V66.7061H22.4769Z",
    fill: "#78D0EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9845 111.741H7.49219V119.233H14.9845H22.4768H29.9692V111.741H22.4768H14.9845Z",
    fill: "#78D0EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49233 104.249H0V111.741H7.49233V104.249Z",
    fill: "#78D0EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4768 104.248H14.9845H7.49219V111.74H14.9845H22.4768H29.9692V104.248H22.4768Z",
    fill: "#C2E8EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49233 89.2633V81.771H0V89.2633V96.7557V104.248H7.49233V96.7557V89.2633Z",
    fill: "#C2E8EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComet);
export default __webpack_public_path__ + "static/media/icon-comet.cdd4572b4303319c7244d345cd2f4735.svg";
export { ForwardRef as ReactComponent };